import { yupResolver } from "@hookform/resolvers/yup";
import { DocketTemplateFormValues } from "./types";
import { schema } from "./constants";
import { FormProvider, useForm } from "react-hook-form";

export interface DocketTemplateFormProviderProps {
  defaultFormValues?: Partial<DocketTemplateFormValues>;
  children?: React.ReactNode;
}

export const DocketTemplateFormProvider = ({
  defaultFormValues,
  children,
}: DocketTemplateFormProviderProps) => {
  const methods = useForm<DocketTemplateFormValues>({
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: {
      ...defaultFormValues,
    },
    resolver: yupResolver(schema),
  });

  return <FormProvider {...methods}>{children}</FormProvider>;
};
